import { get } from "../../utils";
import { endpointConstants } from "../constants";

export const yodaInfoService = {
  getCookie,
  getPrivacy,
  getSizeScale,
};

function getCookie() {
  let endpoint = endpointConstants.YODAINFO.GET_COOKIE;
  return get(endpoint, {});
}

function getPrivacy() {
  let endpoint = endpointConstants.YODAINFO.GET_PRIVACY;
  return get(endpoint, {});
}

function getSizeScale() {
  let endpoint = endpointConstants.YODAINFO.GET_SIZE_SCALE;
  return get(endpoint, {});
}
